import Checkbox from './checkbox';
import Group from './group';
import './styles/index.scss';
const ExpandedCheckbox = Checkbox;
ExpandedCheckbox.Group = Group;
export { Checkbox, Group };
export default ExpandedCheckbox;
